(function(){
  var E10='https://cdn.shopify.com/s/files/1/0687/5814/3019/files/elite10_2ch_03.png?v=1784023941';
  var GX4K='https://cdn.shopify.com/s/files/1/0687/5814/3019/files/gx4k-2ch.jpg?v=1782902328';
  var GX35='https://cdn.shopify.com/s/files/1/0687/5814/3019/files/GX35-Front-and-rear-500by500.jpg?v=1782902385';
  var A1='https://cdn.shopify.com/s/files/1/0687/5814/3019/files/789ed3a8eee295ab5d15b028c63cd262ff5856b8311b3e13f4ddbd8aaf828e99.jpg?v=1780256728&width=600';
  var A2='https://cdn.shopify.com/s/files/1/0687/5814/3019/files/1qIDnmkJ5ZnpY5hfxkdrTKKe6vYB4wh-z_s3000.jpg?v=1780209685&width=600';
  var A3='https://cdn.shopify.com/s/files/1/0687/5814/3019/files/blackvue-parking-mode-night-banner.jpg?v=1784433271&width=600';
  function card(href,imgUrl,label,title,desc,cta,cover){
    var imgWrap = cover
      ? '<div style="height:120px;background:#f6f8fb;overflow:hidden;"><img src="'+imgUrl+'" loading="lazy" alt="" style="width:100%;height:100%;object-fit:cover;display:block;"></div>'
      : '<div style="display:flex;align-items:center;justify-content:center;height:132px;padding:6px;background:#fff;"><img src="'+imgUrl+'" loading="lazy" alt="" style="max-height:100%;max-width:100%;object-fit:contain;"></div>';
    return '<a href="'+href+'" style="text-decoration:none;color:inherit;display:flex;flex-direction:column;flex:1 1 200px;min-width:190px;max-width:260px;border:1px solid #e2e8f0;border-radius:12px;overflow:hidden;background:#fff;">'
      +imgWrap
      +'<div style="padding:11px 13px;">'
      +'<div style="font-size:.66rem;font-weight:700;letter-spacing:.06em;text-transform:uppercase;color:#d97e1c;">'+label+'</div>'
      +'<div style="font-weight:700;color:#0e1320;font-size:.95rem;margin:2px 0 4px;line-height:1.2;">'+title+'</div>'
      +'<div style="font-size:.78rem;color:#64748b;line-height:1.4;">'+desc+'</div>'
      +'<div style="margin-top:8px;color:#1380ec;font-weight:600;font-size:.82rem;">'+cta+' &rarr;</div>'
      +'</div></a>';
  }
  function stripFor(name){
    if(name==='Shop'){
      return card('/products/blackvue-elite-10-2ch-4k-dash-cam', E10, 'The Ultimate Set-Up','BlackVue Elite 10 2CH','Flagship dual 4K front &amp; rear, plus B-130A battery for 24/7 parking power.','Shop',false)
        + card('/products/finevu-gx4k-2ch-4k-dash-cam', GX4K, 'Flagship 4K','FineVu GX4K-2CH','True 4K front + Full HD rear, smart parking mode and a 3-year Australian warranty.','Shop',false)
        + card('/products/finevu-gx35-2ch-2k-dash-cam', GX35, 'Small &amp; Discreet','FineVu GX35-2CH','Tiny 2K front &amp; rear with a 3-year Australian warranty.','Shop',false);
    }
    if(name==='Learn'){
      return card('/blogs/guides/best-dash-cams-australia-2026', A1, 'Buyer&#39;s Guide','Best Dash Cams in Australia (2026)','Our honest rankings &mdash; the exact models we&#39;d buy at every budget.','Read guide',true)
        + card('/blogs/guides/dash-cam-new-car-warranty-australia', A2, 'Myth-Busting','Will a Dash Cam Void My Warranty?','Short answer: no &mdash; but the install matters. What to know before fitting one.','Read guide',true)
        + card('/blogs/guides/how-does-dash-cam-parking-mode-work', A3, 'While You&#39;re Away','How Parking Mode Works','Motion &amp; impact recording while parked &mdash; and the power setup it needs.','Read guide',true);
    }
    return null;
  }
  function inject(){
    document.querySelectorAll('.menu-list__list-item').forEach(function(li){
      var t=li.querySelector('.menu-list__link-title');
      if(!t) return;
      var name=t.textContent.trim();
      var html=stripFor(name);
      if(!html) return;
      var grid=li.querySelector('.mega-menu__grid');
      if(!grid) return;
      if(grid.querySelector('.dcc-menu-featured')) return;
      var strip=document.createElement('div');
      strip.className='dcc-menu-featured';
      strip.innerHTML='<div style="grid-column:1 / -1;margin-top:6px;"><div style="display:flex;flex-wrap:wrap;gap:14px;">'+html+'</div></div>';
      grid.appendChild(strip);
    });
  }
  if(document.readyState!=='loading'){inject();}else{document.addEventListener('DOMContentLoaded',inject);}
  var pending=false;
  function schedule(){if(pending)return;pending=true;setTimeout(function(){pending=false;inject();},200);}
  var mo=new MutationObserver(schedule);
  mo.observe(document.documentElement,{childList:true,subtree:true});
})();